import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const SamsaraFinish = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraFinish/SamsaraFinish")
);

export const SamsaraFinishPage = () => {
  return (
    <Layout>
      <SamsaraFinish />
    </Layout>
  );
};
